"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpTopics = HelpTopics;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _HelpTopicCard = require("./HelpTopicCard");
var _NoHelp = require("./NoHelp");
var _Loading = require("./Loading");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "onClick", "children"],
  _excluded2 = ["topics", "onClick", "testId", "loading", "viewAllUrl"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Title(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Text, _objectSpread({
    truncate: true
  }, rest));
}
function Blank() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Text, {});
}
function DivFormatter(_ref2) {
  var _className$split;
  var className = _ref2.className,
    onClick = _ref2.onClick,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return className !== null && className !== void 0 && (_className$split = className.split(' ')) !== null && _className$split !== void 0 && _className$split.some(function (c) {
    return c.toLowerCase() === 'example';
  }) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpTopicCard.InfoCard, _objectSpread(_objectSpread({
    onClick: onClick
  }, rest), {}, {
    children: children
  })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: className,
    children: children
  });
}
DivFormatter.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  children: _propTypes["default"].any
};
function HelpTopics(_ref3) {
  var topics = _ref3.topics,
    onClick = _ref3.onClick,
    testId = _ref3.testId,
    _ref3$loading = _ref3.loading,
    loading = _ref3$loading === void 0 ? false : _ref3$loading,
    viewAllUrl = _ref3.viewAllUrl,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var components = {
    section: {
      component: _HelpTopicCard.HelpTopicCard,
      props: {
        onClick: onClick,
        testId: testId
      }
    },
    div: {
      component: DivFormatter,
      props: {
        onClick: onClick,
        testId: testId
      }
    },
    main: _grommet.Box,
    article: _grommet.Box,
    h1: Blank,
    h2: Title,
    br: Blank,
    p: {
      props: {
        margin: 'none'
      }
    }
  };
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
      flex: false,
      gap: "medium",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {
        testId: "".concat(testId, "--loading")
      }), viewAllUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpTopicCard.ViewAllCard, {
        testId: "".concat(testId, "--viewall"),
        viewAllUrl: viewAllUrl
      })]
    });
  }
  if (topics) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
      flex: false,
      pad: {
        top: 'small'
      },
      gap: "medium",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Markdown, _objectSpread(_objectSpread({
        components: components,
        "data-testid": "".concat(testId, "--topics")
      }, rest), {}, {
        children: topics.replace(/class=/g, 'className=')
      })), viewAllUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpTopicCard.ViewAllCard, {
        testId: "".concat(testId, "--viewall"),
        viewAllUrl: viewAllUrl
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoHelp.NoHelp, {
    "data-testid": "".concat(testId, "--nohelp"),
    viewAllUrl: viewAllUrl
  });
}
HelpTopics.propTypes = {
  topics: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  testId: _propTypes["default"].string.isRequired,
  loading: _propTypes["default"].bool,
  viewAllUrl: _propTypes["default"].string
};